import { Modal } from "@mui/material";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { closeIco, viewImg } from "../Assets/images/imagesExport";
import toast from "react-hot-toast";

const Table = ({tableFor, tableData }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  // console.log(tableData , "tableData")
  const handleExportReport = async () => {
    handleClearRows();

    const formattedData = {
      location: selectedRows[0].location,
      date: selectedRows[0].date,
      data: selectedRows.map((row) => ({
        croud: row.croundCount,
        image: `/${row.imageName}`,
        bus: row.busCount ? row.busCount : "-",
        time: row.time,
      })),
    };

    //pdf creation starts here anand
    toast.success("PDF creation started successfully! ");

    try {
      const response = await axios.post(
        "https://delivery.inspect.indrones.com/api/v1/getPdf/generate_inflight_report",
        formattedData,
        {
          responseType: "blob", // Tell Axios to expect a binary response
        }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });

      toast.success("PDF Created!");

      //pdfcreation ends here anand

      // Create a download link and trigger a click to initiate download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `report.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      //pdfcreation failed anand
      toast.error("PDF creation failed!");
      console.error("err", error);
    }

    setSelectedRows([]);
  };

  const columns = [
    {
      name: "Sr. No",
      selector: (row) => row.id,
      sortable: true,
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      center: true,
    },
    {
      name: "Time",
      selector: (row) => row.time,
      sortable: true,
      center: true,
    },
    {
      name: "Crowd Count",
      selector: (row) => row.croundCount,
      sortable: true,
      center: true,
    },
    {
      name: "Bus Count",
      selector: (row) => (row.busCount ? row.busCount : "-"),
      sortable: true,
      center: true,
    },
    {
      name: "View Image",
      cell: (row) => (
        <button onClick={() => viewImage(row.imageName)}>
          <img className="" src={viewImg} alt="" srcset="" />
        </button>
      ),
      center: true,
    },
  ];

  const data = tableData?.map((imageName, index) => {
    let date;
    let time;
    let croundCount;
    let location;
    let busCount = "-";

    const parts = imageName?.split(/_|\/|-|\s/);
    // console.log(parts, "parts");
    if (parts.length > 9) {
      location = parts?.slice(0, 3).join(" ");
      date = parts?.slice(4, 7).join("-");
      time = parts?.slice(7, 8).join(":");
      croundCount = parts[8]?.split(".")[0];
      busCount = parts[9]?.split(".")[0];
    } else  if (parts.length === 9) {
      location = parts?.slice(0, 2).join(" ");
      date = parts?.slice(3, 6).join("-");
      time = parts?.slice(6, 7).join(":");
      croundCount = parts[7]?.split(".")[0];
      busCount = parts[8]?.split(".")[0];
    } else {
      location = parts?.[0];
      date = parts?.slice(2, 5).join("-");
      time = parts?.slice(5, 6).join(":");
      croundCount = parts[6]?.split(".")[0];
      busCount = parts[7]?.split(".")[0];
    }

    // Create a UTC string
    const utcString = `${date}T${time}Z`;

    // Convert UTC to IST
    const istOptions = { timeZone: "Asia/Kolkata" };
    const istDate = new Date(utcString).toLocaleString("en-US", istOptions);

    return {
      location: location,
      id: index + 1,
      date: istDate?.split(",")[0], // Extract date part
      time: istDate?.split(",")[1], // Extract time part
      croundCount,
      busCount: busCount,
      imageName,
    };
  });

  const viewImage = (imageName) => {
    handleOpen();
    setSelectedImage(imageName);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage("");
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minHeight: 200,
    minWidth: 400,

    boxShadow: 24,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);
  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  };

  return (
    <div className="my-auto">
      {/* <DataTable columns={columns} data={tableData} pagination /> */}

      {tableData.length === 0 ? (
        <h1 className="mx-auto text-3xl text-center">{tableFor !== "All" ?  `No data to show for ${tableFor?.split("-").join(" ")}`   :  "Please Select Location" }</h1>
      ) : (
        <>
          <DataTable
            columns={columns}
            data={data}
            pagination
            selectableRows
            selectableRowsHighlight
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggledClearRows}
            striped
          />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            selectedImage={selectedImage}
          >
            <div className=" rounded-lg bg-white" style={style}>
              <div className="py-2 text-center rounded-tl-lg rounded-tr-lg bg-yellow-400 flex justify-between items-center ">
                <h1 className=" text-lg font-semibold tracking-wide grow">
                  Image viewer
                </h1>
                <span
                  onClick={handleClose}
                  className="mx-2  hover:scale-125 rounded-full hover:border hover:border-white"
                >
                  <img src={closeIco} alt="" srcset="" />{" "}
                </span>
              </div>
              <div className="p-2">
                <img
                  className="my-auto  rounded-md"
                  src={`https://d38m9edjeqfsnf.cloudfront.net/${selectedImage}`}
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          </Modal>

          <div className="flex gap-4 items-center ml-4 ">
            <button
              onClick={() => {
                selectedRows.length === 0
                  ? toast.error("Please select rows to export report.")
                  : handleExportReport();
              }}
              className=" bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded"
            >
              Export Report
            </button>
            <h3 className="text-md py-1 font-semibold  outline-dashed outline-gray-500 outline-1  px-2 rounded">
              Selected Rows:<span className=""> {selectedRows.length}</span>
            </h3>
          </div>
        </>
      )}
    </div>
  );
};

export default Table;
